import { normalizeHelper, createAsyncAction } from '../../utils/asyncHelpers';
import consumer from '../../schemas/consumer';
import * as actionTypes from '../../constants/consumerAddActionTypes';

export const addConsumer = createAsyncAction(
  actionTypes.CONSUMER_ADD,
  (data) => data,
  normalizeHelper(consumer)
);
